import { createSlice } from "@reduxjs/toolkit";

const initialBinState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: [],
    binForEdit: undefined,
    lastError: null,
    message: null,
    error: null,
};
export const callTypes = {
    list: "list",
    action: "action"
};

export const binSlice = createSlice({
    name: "bins",
    initialState: initialBinState,
    reducers: {
        catchError: (state, action) => {
            state.error = action.payload.error.clientMessage;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            state.message = null;

            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        endCall: (state, action) => {
            state.error = null;
            state.message = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        // getBinById
        binFetched: (state, action) => {
            state.actionsLoading = false;
            state.binForEdit = action.payload.binForEdit;
            state.floorPlans = action.payload.binForEdit.floorPlans;
            state.error = null;

        },
        // getBinChart
        binChartFetched: (state, action) => {

            state.actionsLoading = false;
            state.binChart = action.payload.binChart;
            state.error = null;

        },
        // getBinChart
        binHourlyChartFetched: (state, action) => {
            state.actionsLoading = false;
            state.binChartHour = action.payload.binChartHour;
            state.error = null;

        },
        // getBinChart
        binHourlyZoneChartFetched: (state, action) => {
            state.actionsLoading = false;
            state.binChartHourZone = action.payload.binChartHourZone;
            state.error = null;

        },
        // get list data
        binsFetched: (state, action) => {
            const { totalCount, entities } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalCount;
            state.binForEdit = undefined;
            state.floorPlans = undefined;
            state.binChart = undefined;
            state.binChartHour = undefined;
            state.binChartHourZone = undefined;
        },
        // createBin
        binCreated: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            state.message = action.payload.msgResponse;
        },
        // updateBin
        binUpdated: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.message = action.payload.msgResponse;
        },
        // binDeleted
        binDeleted: (state, action) => {
            state.error = null;
            state.message = action.payload.msgResponse;
            state.actionsLoading = false;
        },
        setMessage: (state, action) => {
            state.error = null;
            state.message = action.payload.msgResponse;
        },
        floorPlanDeleted: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.floorPlans = state.floorPlans.filter(item => item.id !== action.payload.id);
        },
        floorPlanUpdated: (state, action) => {
            const { id, floorPlan } = action.payload;
            state.error = null;
            state.actionsLoading = false;
            state.floorPlans = state.floorPlans.map((data) => {

                if (data.id === id) {
                    return floorPlan;
                }

                return data;
            });
        }

    }
});
